import { DIRECTION_THRESHOLD, SWIPE_THRESHOLD, HORIZONTAL_RATIO } from '~~/constants/simpleCarousel';

type SwipeDirection = 'left' | 'right';

export const useCarouselSwipe = (onSwipe: (direction: SwipeDirection) => void) => {

  let start: { x: number; y: number; identifier: number } | null = null;
  let direction: 'pending' | 'horizontal' | 'vertical' = 'pending';

  const handleTouchCancel = () => {

    start = null;

  };

  const handleTouchStart = (event: TouchEvent) => {

    const touch = event.touches[0];

    if (event.touches.length !== 1 || !touch) {

      handleTouchCancel();

      return;

    }

    start = { x: touch.clientX, y: touch.clientY, identifier: touch.identifier };
    direction = 'pending';

  };

  const updateDirection = (touch: Touch) => {

    if (!start) {

      return;

    }

    const distanceX = Math.abs(touch.clientX - start.x);
    const distanceY = Math.abs(touch.clientY - start.y);

    if (Math.max(distanceX, distanceY) < DIRECTION_THRESHOLD) {

      return;

    }

    if (direction === 'pending') {

      direction = distanceX > distanceY * HORIZONTAL_RATIO ? 'horizontal' : 'vertical';

    }

  };

  const handleTouchMove = (event: TouchEvent) => {

    if (!start) {

      return;

    }

    const touch = event.touches[0];

    if (event.touches.length !== 1 || !touch || touch.identifier !== start.identifier) {

      handleTouchCancel();

      return;

    }

    updateDirection(touch);

  };

  const handleTouchEnd = (event: TouchEvent) => {

    const touch = Array.from(event.changedTouches).find(touch => touch.identifier === start?.identifier);

    if (!start || !touch || event.touches.length > 0) {

      handleTouchCancel();

      return;

    }

    updateDirection(touch);

    if (direction !== 'pending' && event.cancelable) {

      event.preventDefault();

    }

    const distanceX = touch.clientX - start.x;
    const distanceY = touch.clientY - start.y;
    start = null;

    if (direction === 'horizontal'
      && Math.abs(distanceX) >= SWIPE_THRESHOLD
      && Math.abs(distanceX) > Math.abs(distanceY) * HORIZONTAL_RATIO) {

      onSwipe(distanceX < 0 ? 'left' : 'right');

    }

  };

  return { handleTouchStart, handleTouchMove, handleTouchEnd, handleTouchCancel };

};
